import React from "react";

class ResponsibleDept extends React.Component {
    constructor(props) {
        super(props);
        this.responsibleDeptInitials = [
            { id: 1, status: false, tag: "Accident, Casualty and Emergency" },
            { id: 2, status: false, tag: "Surgery (operating theater)" },
            { id: 3, status: false, tag: "Outpatient" },
            { id: 4, status: false, tag: "Intensive Care Unit" },
            { id: 5, status: false, tag: "Cardiology" },
            { id: 6, status: false, tag: "Neurology" },
            { id: 7, status: false, tag: "Psychiatry" },
            { id: 8, status: false, tag: "Radiology" },
            { id: 9, status: false, tag: "Medical Laboratory" },
            { id: 10, status: false, tag: "Pharmacy" },
            { id: 11, status: false, tag: "Rehabilitation and Therapy" },
            { id: 12, status: false, tag: "ENT section" },
            { id: 13, status: false, tag: "Geriatric" },
            { id: 14, status: false, tag: "Gastroenterology" },
            { id: 15, status: false, tag: "Hematology" },
            { id: 16, status: false, tag: "Pediatrics" },
            { id: 17, status: false, tag: "Oncology" },
            { id: 18, status: false, tag: "Ophthalmology" },
            { id: 19, status: false, tag: "Urology" },
            { id: 20, status: false, tag: "Orthopedic" },
            { id: 21, status: false, tag: "Nursing" },
            { id: 22, status: false, tag: "Nutrition and Dietetics" },
        ];
        this.handleSelectedOptions = (nextAllergy, status) => {
            (this.responsibleDeptInitials.map(t => {
                if (+t.id === +nextAllergy.id) {
                    t.status = status
                    return nextAllergy;
                } else {
                    return t;
                }
            }));
            props.ifAllergy(this.responsibleDeptInitials)
        };
        if (this.props.preSelected.length) {
            console.log('Loophole');
            this.props.preSelected.map(item => {
                this.handleSelectedOptions(item, true)
            })
        }
    }
    render() {
        return (
            <div className="flex flex-col border mt-4 pl-4 rounded">
                <h1 className="my-5 text-gray-600">
                    Select from the given category
                </h1>
                {this.responsibleDeptInitials.map((item, index) =>
                    <label className="mr-2 mb-4 flex items-center" key={`label-check${item.id}respons`}>
                        <input
                            onChange={(e) => this.handleSelectedOptions(item, e.target.checked)}
                            checked={item.status}
                            type="checkbox"
                            id={`checkbox-dept${index + item.tag}-tag`}
                            name={`${item.tag}`}
                            className="mr-1"
                        />
                        <span className="ml-1">{item.tag}</span>
                    </label>
                )}
            </div>
        );
    }
}
export default ResponsibleDept;

